import request from '@/utils/request'

// 获取车辆列表
export function getList(data) {
  return request.post('/vehicle/getPage', data);
}
// 获取车牌号列表
export function getVehicleList(data) {
  return request.post('/vehicle/list', data);
}

// 新增车辆信息
export function createVehicle(data) {
  return request.post('/vehicle/save', data);
}

// 更新车辆信息
export function updateVehicle(data) {
  return request.post('/vehicle/updateById', data);
}

// 删除车辆信息
export function deleteVehicle(data) {
  return request.post('/vehicle/deleteBatch', data);
}
